<template>
  <div class="yk-ext-service-detail">
      <el-carousel indicator-position="outside" :height="bannerHeight">
        <el-carousel-item v-for="(item, index) in imgList" :key="'banner'+index">
          <img width="100%" height="auto" alt="" title="" :src="item">
        </el-carousel-item>
      </el-carousel>
    <div class="solution">
      <p class="title">{{solutionInfo.solutionName}}</p>
      <p class="title2" v-html="solutionInfo.solutionBrief"></p>
      <p class="title2" v-html="solutionInfo.solutionContent"></p>
      <img class="image" v-if="solutionInfo.solutionPic" :src="solutionInfo.solutionPic" :alt="solutionInfo.solutionName">
    </div>
    <div class="solutionList">
        <div class="item" v-for="(item, index) in solutionList" :key="'solutionList'+index">
          <div class="tabName" :class="currentIndex===index?'active':''" @click="clickName(item, index)">
            <p>{{item.title}}</p><i :class="currentIndex===index?'el-icon-arrow-down':'el-icon-arrow-up'"></i>
          </div>
          <div class="text" v-show="currentList.findIndex(val => {return val === index}) >= 0" v-html="item.content"></div>
        </div>
    </div>
    <div class="successCase">
      <div class="box" v-for="(item, index) in projects" :key="'projects'+index">
        <p class="title">{{item.title}}</p>    
        <div class="html" v-html="item.content"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      solutionInfo: {},
      projects: [],
      typeId: -1,
      imgList: [],
      solutionList: [],
      currentIndex: null,
      currentList: [],
      bannerHeight:document.documentElement.clientWidth*537/1920+"px"
    }
  },
  mounted () {
    this.getData()
    this.getImgList()
  },
  methods: {
    getData () {
      if (this.$route.query && this.$route.query.extId) {
        this.typeId = this.$route.query.extId
        this.$get(`/api/extService/detail/${this.$route.query.extId}`).then(res => {
          console.log(res);
          if(res!=undefined && res!=null){
          this.solutionInfo.solutionName = res.data.extServiceName || ''
          this.solutionInfo.solutionBrief = res.data.extServiceBrief || ''
          this.solutionInfo.solutionContent = res.data.extServiceContent || ''
          this.solutionInfo.solutionPic = res.data.extServicePic || ''
          // this.projects = res.data.projects || []
          var projectList = [];
          var solutionList = [];
          if(res.data.projects){
            for(var i=0;i<res.data.projects.length;i++){
             var project = res.data.projects[i];
             if(project.itemType == 'default'){
              solutionList.push(project);
             }else{
              projectList.push(project);
             }
            }
          }
          this.projects = projectList;
          this.solutionList = solutionList;
          this.$forceUpdate()
          }
        })
      }
    },
    getImgList () {
      this.imgList = []
      let product = this.bannerList.find(val => {return val.typeLabel === 'ext-service'})
      if (product && product.child && product.child.length > 0 && this.typeId) {
        let obj = product.child.find(val => {return val.id == this.typeId})
        if (obj && obj.bannerList) {
          this.imgList = obj.bannerList
        }        
      }
    },
    clickName (item, index) {
      if(this.currentIndex == index){
        this.currentIndex = null;
      }else{
        this.currentIndex = index
      }
      let idx = this.currentList.findIndex(val => {return val === index})
      if (idx >= 0) {
        this.currentList.splice(idx, 1)
      } else {
        this.currentList.push(index)
      }
    }
  },
  watch: {
    bannerList: {
      handler() {
        this.getImgList()
      },
      deep: true
    }
  },
  beforeDestroy () {
  },
  components: {},
  created() {
    window.onreset = () =>{
      return (()=>{
        this.bannerHeight = document.documentElement.clientWidth *537/1920;
      })
    }
  },
}
</script>
<style scoped lang="stylus">
.yk-ext-service-detail
  width 100%
  color $c1
  
  .solution
    color $c1
    width $pageWidth
    text-align center
    margin 50px auto
    .title   
      font-size 48px
      font-weight 600
      margin-bottom 20px
    .title1
      font-size 20px
      line-height 30px
    .title2
      font-size 20px
      line-height 30px
    .image
      width 100%
      margin 20px auto
    
  .successCase
    width $pageWidth
    margin 0 auto
    .box
      margin-bottom 40px
      text-align center
      .title   
        font-size 48px
        font-weight 600
        margin-bottom 20px
      .html
        font-size 20px
        line-height 30px
  .solutionList
    margin 30px auto
    width 75%
    .item
      margin-bottom 40px
    .tabName
      padding 0 20px
      font-size 24px
      line-height 60px
      font-weight 600
      border 2px solid #D3D3D3
      display flex
      border-radius 5px
      cursor pointer
      justify-content space-between
      i
        margin-top 20px
    .active
      border 2px solid #03459D
      color #03459D
    .text
      margin-top 30px
      font-size 20px
      line-height 40px
@media screen and (max-width: 900px)
  .yk-ext-service-detail
    .solution
      width 94%
      .title  
        font-size 1.2rem
      .title1   
        font-size 0.8rem
      .title2  
        font-size 0.8rem
    .solutionList
      margin 10px auto  
      width 94%
      .item
        margin-bottom 1rem
      .tabName
        font-size 0.9rem
        line-height 2.5rem
        margin-top 0.8rem
      .text
        font-size 0.75rem
        line-height 1.5rem
    .successCase
      width 94%
      .box
        margin-bottom 1rem  
        .title  
          font-size 1.2rem
        .html  
          font-size 0.8rem

</style>